import { ResponseType } from "../../Types/ServicesType/servicesType";
import { BillingDetailsListType, BillingListResponseType } from "./types";
import dayjs, { Dayjs } from "dayjs";
import api from "@services/apiList";
import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
const { clinicId, user } = getConstants();
const { billing } = api;

export const getBillingList = async (params: {
  filter: {
    search: string;
    searchDate: Dayjs;
    paymentMode: number | null;
  };
  pageSize?: number;
  pageNumber?: number;
}): Promise<
  ResponseType<{
    items: BillingListResponseType[];
    totalCount: number;
  }>
> => {
  try {
    return (
      await instance.post(billing.billingList, {
        clinicId,
        ...params,
        filter: {
          ...params.filter,
          searchDate: dayjs(params.filter.searchDate).format("YYYY-MM-DD"),
          paymentMode:
            params.filter.paymentMode == 2 ? null : params.filter.paymentMode,
        },
      })
    ).data;
  } catch (error: any) {
    return error;
  }
};

export const getBillingDetails = async (
  id: string,
  insuranceName:string | null | undefined,
  codetype:string
): Promise<
  ResponseType<{
    billingDetails: BillingDetailsListType[];
    amountDetails: {
      totalAmount: number;
      insDiscount: number;
      insAmount: number;
      patShare: number;
      totalDiscountedAmount: number;
    };
    totalNumber: number;
  }>
> => {
  return (await instance.get(codetype == "CPT" ?  `${billing.billedItems}/${clinicId}?id=${id}` : `${billing.billedItemsv2}/${clinicId}?id=${id}&insname=${insuranceName || ""}`))
    .data;
};

/** Full line row + encounterId (same keys as previous client payload) + optional discount fields */
export type EditBillDetailsPayload = BillingDetailsListType & {
  encounterId: number;
};

export const editBillDetails = async (
  details: EditBillDetailsPayload,
): Promise<ResponseType<string>> => {
  return (await instance.post(billing.billingCptEdit, { ...details, clinicId }))
    .data;
};

export const deleteBillItem = async (details: {
  encounterId: number;
  groupId: number;
  id: number;
}): Promise<ResponseType<number>> => {
  return (await instance.post(billing.billDelete, { ...details, clinicId }))
    .data;
};

export const getBilledPatient = async (params: {
  filter: {
    search: string;
    searchDate: Dayjs;
  };
  pageNumber: number;
  pageSize: number;
}): Promise<
  ResponseType<{ items: BillingListResponseType[]; totalCount: number }>
> => {
  return (
    await instance.post(billing.billedDetails, {
      clinicId,
      ...params,
      filter: {
        ...params.filter,
        searchDate: dayjs(params.filter.searchDate).format("YYYY-MM-DD"),
      },
    })
  ).data;
};

export const getBillPrint = async (
  id: number
): Promise<ResponseType<{ invoice: string | null }>> => {
  return (await instance.get(`${billing.billPrint}/${clinicId}?id=${id}`)).data;
};

export const getBillPrintV2 = async (payload:{
  insname:string,
  encounterId:number,
  clinicId:number
}): Promise<ResponseType<{ invoice: string | null }>> => {
  return (await instance.post(billing.billPrintV2,payload)).data;
};

export const saveBill = async (params: {
  encounterId: number;
  totalAmount: number;
  insDiscount: number;
  insAmount: number;
  patShare: number;
  itemsForBill: BillingDetailsListType[];
  destination:string;
}): Promise<ResponseType<string | null>> => {
  return (
    await instance.post(billing.billingSave, {
      ...params,
      createdById: user?.login_id,
      clinicId,
      status: 1,
    })
  ).data;
};

export const printOutHouse = async ({id}:{id:string}):Promise<ResponseType<string>>  => {
  return (await instance.get(`${billing.outHousePrint}/${clinicId}?id=${id}`)).data;
};
